<ng-container *ngIf="costCenterState$ | async as state">
    <h1 mat-dialog-title class="active">
        {{"app.dialog.hourly-wages.title.header" | translate: { kostenstelle: costCenter.name } }}
    </h1>
    <div mat-dialog-content>
        <mat-progress-bar color="accent" [style.visibility]="state.isLoadingHourlyWages ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="dialogHeader">
            <mat-generic-input (inputFormGroupChange)="onFormGroupChange($event)" [fields]="state.hourlyWageFilter"></mat-generic-input>
            <button
                mat-mini-fab
                color="primary"
                matTooltip="{{ 'app.dialog.hourly-wage.actions.add.label' | translate }}"
                (click)="onOpenAddDialog()"><mat-icon>add</mat-icon></button>
        </div>
                <table mat-table [dataSource]="dataSource" matSort>
                    <ng-container matColumnDef="validFrom">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.hourly-wage.validFrom.label" | translate }}</th>
                        <td mat-cell *matCellDef="let wage">{{wage.validFrom | date: 'dd.MM.yyyy'}}</td>
                    </ng-container>

                    <ng-container matColumnDef="validTo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.hourly-wage.validTo.label" | translate }}</th>
                        <td mat-cell *matCellDef="let wage">{{wage.validTo | date: 'dd.MM.yyyy'}}</td>
                    </ng-container>

                    <ng-container matColumnDef="costAccountingType">
                        <th mat-header-cell *matHeaderCellDef>{{ "app.model.hourly-wage.costAccountingType.label" | translate }}</th>
                        <td mat-cell *matCellDef="let wage">{{wage.costAccountingType.name}}</td>
                    </ng-container>

                    <ng-container matColumnDef="hourlyWageCt">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">{{ "app.model.hourly-wage.wage.label" | translate }}</th>
                        <td mat-cell *matCellDef="let wage">{{wage.hourlyWageCt / 100 | currency:'EUR':'symbol':'1.2-2'}}</td>
                    </ng-container>

                    <ng-container matColumnDef="delete">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let wage">
                            <button
                                color="warn"
                                mat-icon-button
                                (click)="onDeleteWage(wage)"
                                matTooltip="{{ 'app.dialog.hourly-wage.actions.delete.label' | translate }}">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="state.hourlyWageColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: state.hourlyWageColumns;"></tr>
                </table>
        </div>
</ng-container>
